import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import { useState } from 'react';
import { X } from 'lucide-react';

// Pages
import HomePage from './components/HomePage';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import BlogPage from './components/BlogPage';
import BlogArticlePage from './components/BlogArticlePage';

// Service Pages
import AIServicePage from './components/AIServicePage';
import AppServicePage from './components/AppServicePage';
import WebServicePage from './components/WebServicePage';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ScrollToTopButton />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogArticlePage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services/ai" element={<AIServicePage />} />
        <Route path="/services/app" element={<AppServicePage />} />
        <Route path="/services/web" element={<WebServicePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
